import crypto from "crypto";

const ENC_KEY = "4k2bv6CRCbCYoVM9CfpIzjh2slagTK5N"; 

export function encryptAESCBC(plaintext: string) {
  const key = Buffer.from(ENC_KEY, "utf-8");
  const iv = crypto.randomBytes(16);
  const cipher = crypto.createCipheriv("aes-256-cbc", key, iv);
  let encrypted = cipher.update(plaintext, "utf-8", "hex");
  encrypted += cipher.final("hex");
  return iv.toString("hex") + ":" + encrypted;
}

export function decryptAESCBC(ciphertext: string): string {
  const key = Buffer.from(ENC_KEY, "utf-8");

  // Split IV and encrypted text
  const [ivHex, encrypted] = ciphertext.split(":");

  // Convert IV from hex to Buffer
  const iv = Buffer.from(ivHex, "hex");

  const decipher = crypto.createDecipheriv("aes-256-cbc", key, iv);

  let decrypted = decipher.update(encrypted, "hex", "utf-8");
  decrypted += decipher.final("utf-8");

  return decrypted;
}
